import { InternalCustomDataField } from 'models/CustomDataField';

export enum PreArrivalFormFields {
  PRIMARY_GUEST_FIRST_NAME = 'PRIMARY_GUEST_FIRST_NAME',
  PRIMARY_GUEST_LAST_NAME = 'PRIMARY_GUEST_LAST_NAME',
  PRIMARY_GUEST_EMAIL = 'PRIMARY_GUEST_EMAIL',
  PRIMARY_GUEST_PHONE_NUMBER = 'PRIMARY_GUEST_PHONE_NUMBER',
  PRIMARY_GUEST_AGE = 'PRIMARY_GUEST_AGE',
  PRIMARY_GUEST_GOVERNMENT_ID = 'PRIMARY_GUEST_GOVERNMENT_ID',
  PRIMARY_GUEST_NUMBER_OF_GUESTS = 'PRIMARY_GUEST_NUMBER_OF_GUESTS',

  OTHER_GUEST_FIRST_NAME = 'OTHER_GUEST_FIRST_NAME',
  OTHER_GUEST_LAST_NAME = 'OTHER_GUEST_LAST_NAME',
  OTHER_GUEST_EMAIL = 'OTHER_GUEST_EMAIL',
  OTHER_GUEST_PHONE_NUMBER = 'OTHER_GUEST_PHONE_NUMBER',
  OTHER_GUEST_AGE = 'OTHER_GUEST_AGE',
  OTHER_GUEST_GOVERNMENT_ID = 'OTHER_GUEST_GOVERNMENT_ID',

  ARRIVAL_FLIGHT_NUMBER = 'ARRIVAL_FLIGHT_NUMBER',
  ARRIVAL_ESTIMATED_ARRIVAL_TIME = 'ARRIVAL_ESTIMATED_ARRIVAL_TIME',
  ARRIVAL_ESTIMATED_DEPARTURE_TIME = 'ARRIVAL_ESTIMATED_DEPARTURE_TIME',
  ARRIVAL_REASON_FOR_TRIP = 'ARRIVAL_REASON_FOR_TRIP',

  OTHER_HOSTING_EVENTS = 'OTHER_HOSTING_EVENTS',
  OTHER_HAS_VISITORS = 'OTHER_HAS_VISITORS',
  OTHER_AGREE_HOUSE_RULES = 'OTHER_AGREE_HOUSE_RULES',

  CUSTOM = 'CUSTOM',
}

export enum PreArrivalFormTypes {
  INPUT = 'INPUT',
  INPUT_MAY_BE_PREFILLED_CHANNEL = 'INPUT_MAY_BE_PREFILLED_CHANNEL',
  INPUT_PREFILLED = 'INPUT_PREFILLED',
  UPLOAD_SELECT_INPUT = 'UPLOAD_SELECT_INPUT',
  SELECT = 'SELECT',
}

export type DisplayPreArrivalFormField = Omit<
  InternalCustomDataField,
  'uid' | 'agencyUid' | 'index'
> &
  Partial<Pick<InternalCustomDataField, 'uid' | 'agencyUid' | 'index'>> & {
    id: PreArrivalFormFields;
    validation: 'REQUIRED' | 'OPTIONAL';
  };

export type InformationMap = Record<
  PreArrivalFormFields,
  DisplayPreArrivalFormField
>;

export type PreArrivalFormValues = InformationMap & {
  newCustomFields: Record<string, DisplayPreArrivalFormField>;
  customFields: Record<string, DisplayPreArrivalFormField>;
};
